module.exports = __webpack_public_path__ + "static/media/my_notifications_icon_active.4d7eee3f.svg";